// The victory lap and the winner's crash on it, shared by the head renderer
// (every worm offline, opponents online) and the predicted renderer (your own
// worm online), so the two can never drift apart again.
//
// The crash must not hinge on comparing a worm's render clock to the death
// event's time. Online the two come from different places: the track ends where
// the crashing client stopped, the player_died event is stamped with the host's
// clock when the crash report arrived. Either can be the later one, and a worm
// clock that stops at its track end then never reaches the event, so the
// celebration kept playing (or froze) over a crashed worm. So: once a death
// event exists, the crash shows when the worm's clock reaches it OR when the
// worm's head has reached the end of its track (it is not moving any more).

var SLACK = 0.001; // the wire rounds segment times (0.1ms) but not event times

// The latest victory_lap event that has happened at `time` (a new round's
// fresh gameState has none yet).
export function getVictoryLapEvent(gameState, time) {
    var events = gameState.gameEvents;
    for (var i = events.length - 1; i >= 0; i--) {
        if (events[i].type === "victory_lap") {
            return events[i].time <= time ? events[i] : null;
        }
    }
    return null;
}

// The lap winner's player_died event once their crash should show, else null.
//   clock    : the worm's render time
//   trackEnd : the end time of the worm's track (its head stops there)
//   stopped  : optional, true when the caller already knows the worm crashed
//              (your own worm online: its local collision said so, before the
//              host's event has made the round trip)
export function getLapDeath(gameState, lapEvent, playerId, clock, trackEnd, stopped) {
    var events = gameState.gameEvents;
    for (var i = events.length - 1; i >= 0; i--) {
        var e = events[i];
        if (e.type === "victory_lap") break; // only deaths after the lap began
        if (e.type === "player_died" && e.playerId === playerId && e.time > lapEvent.time) {
            if (e.time <= clock + SLACK || (typeof trackEnd === "number" && clock >= trackEnd - SLACK)) return e;
            return null;
        }
    }
    if (stopped) return { type: "player_died", playerId: playerId, time: Math.max(lapEvent.time, typeof trackEnd === "number" ? trackEnd : clock) };
    return null;
}

// The crash sequence runs on the frame clock from the moment it first shows,
// never off the worm's clock (that stops dead at the crash, which froze the
// sequence on its first frame). One per renderer; keyed per player + lap, so a
// new round's crash starts fresh.
export function LapCrashClock() {
    var seenAt = {};
    return function elapsed(playerId, lapEvent, frameTime) {
        var key = playerId + ":" + lapEvent.time;
        if (seenAt[key] === undefined) seenAt[key] = frameTime;
        return Math.max(0, frameTime - seenAt[key]);
    };
}
